import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

// Enveloppe générique d'ApexCharts pour les cartes du tableau de bord (anneau, barres...) :
//   <div data-controller="apex-chart" data-apex-chart-options-value="<%= {...}.to_json %>"></div>
// Les options sont celles d'ApexCharts, construites dans la vue.
//
// Avec data-apex-chart-datasets-value ({ clé: { labels, series } }) et des boutons
// data-action="apex-chart#switch" data-apex-chart-dataset-param="clé", le contrôleur
// (alors posé sur un parent, le graphique étant la cible "canvas") bascule entre
// plusieurs jeux de données — onglets Mois / Trimestre / Semestre.
export default class extends Controller {
  static targets = ["canvas", "tab"]
  static values = { options: Object, datasets: Object, empty: String }

  connect() {
    const canvas = this.hasCanvasTarget ? this.canvasTarget : this.element
    const series = this.optionsValue.series || []
    const values = typeof series[0] === "object" ? series.flatMap((s) => s.data) : series
    if (this.emptyValue && !values.some((value) => value > 0)) {
      canvas.innerHTML = `<p class="text-muted text-center mb-0">${this.emptyValue}</p>`
      return
    }

    this.chart = new ApexCharts(canvas, this.optionsValue)
    this.chart.render()
  }

  disconnect() {
    this.chart?.destroy()
  }

  switch(event) {
    const dataset = this.datasetsValue[event.params.dataset]
    if (!dataset || !this.chart) return

    this.tabTargets.forEach((tab) => tab.classList.toggle("active", tab === event.currentTarget))
    this.chart.updateOptions({
      series: [{ name: this.optionsValue.series[0].name, data: dataset.series }],
      xaxis: { categories: dataset.labels }
    })
  }
}
